import gql from 'graphql-tag';

import { clientWeb } from '../graphqlAPI';

const USER_UNLINK_SPOTIFY = gql`
  mutation Post($userEmail: String!) {
    userUnLinkSpotify(
      userEmail: $userEmail,
      ){
        isAuth
        isEdited
        token
        error
    }
}`;

const userUnLinkSpotify = async (userEmail) => {
  try {
    const result = await clientWeb.mutate({
      mutation: USER_UNLINK_SPOTIFY,
      variables: {
        userEmail,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userUnLinkSpotify: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userUnLinkSpotify Error: ${error}`);
    return null;
  }
};

export default userUnLinkSpotify;
